<template>
  <!--
      作者：luoyiming
      时间：2020-06-01
      描述：插件中心-团购-添加
    -->
  <div class="product-add pb50">
    <!--添加团购-->
    <div class="common-form">{{ $t('基本信息') }}</div>
    <el-form-item :label="$t('团购名称')" prop="group_name" :rules="[{ required: true, message: $t('请输入团购名称') }]">
      <el-input v-model="form.group_name" :placeholder="$t('请输入团购名称')" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="$t('须知')" prop="describe" :rules="[{ required: true, message: $t('请输入须知') }]">
      <el-input type="textarea" rows="3" v-model="form.describe" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="$t('到期类型')">
      <el-radio-group v-model="form.expire_type">
        <el-radio :label="10">{{ $t('购买后生效') }}</el-radio>
        <el-radio :label="20">{{$t('固定时间')}}</el-radio>
      </el-radio-group>
    </el-form-item>
    <div v-if="form.expire_type == 10">
      <el-form-item :label="$t('有效天数')" prop="expire_day" :rules="[{ required: true, message: $t('请输入有效天数') }]">
        <el-input v-model="form.expire_day" :placeholder="$t('请输入有效天数')" type="number" class="max-w460"></el-input>
      </el-form-item>
    </div>
    <div v-else>
      <el-form-item :label="$t('有效时间')" prop="time" :rules="[{ required: true, message: $t('请输入有效时间') }]">
        <el-date-picker v-model="form.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
          :range-separator="$t('至')" :start-placeholder="$t('开始日期')" :end-placeholder="$t('结束日期')">
        </el-date-picker>
      </el-form-item>
    </div>
    <el-form-item :label="$t('团购图片')" :rules="[{ required: true, message: $t('请上传团购图片') }]" prop="image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div class="item" v-for="(item, index) in form.image" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                  class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openUpload"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>
    <el-form-item :label="$t('划线价格')" prop="line_price" :rules="[{ required: true, message: $t('请输入划线价格') }]">
      <el-input v-model="form.line_price" :placeholder="$t('请输入划线价格')" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="$t('销售价格')" prop="group_price" :rules="[{ required: true, message: $t('请输入销售价格') }]">
      <el-input v-model="form.group_price" :placeholder="$t('请输入销售价格')" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="$t('虚拟销量')" prop="sales_initial" :rules="[{ required: true, message: $t('请输入虚拟销量') }]">
      <el-input type="number" v-model="form.sales_initial" :placeholder="$t('请输入虚拟销量')" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="$t('适用门店')">
      <el-radio-group v-model="form.suit_type">
        <el-radio :label="10">{{ $t('全部') }}</el-radio>
        <el-radio :label="20">{{ $t('部分') }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="$t('选择门店')" v-if="form.suit_type == 20" prop="shop_supplier_id"
      :rules="[{ required: true, message: $t('请选择门店') }]">
      <el-select v-model="form.shop_supplier_id" multiple :placeholder="$t('请选择')">
        <el-option v-for="(item, index) in form.supplier" :key="index" :label="item.name"
          :value="item.shop_supplier_id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('团购状态')">
      <el-radio-group v-model="form.group_status">
        <el-radio :label="1">{{ $t('显示') }}</el-radio>
        <el-radio :label="0">{{ $t('隐藏') }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="$t('每日限购数量')">
      <el-input type="number" v-model="form.limit_num" :placeholder="$t('请输入数字')" class="max-w460"></el-input>
      <div class="gray9">{{$t('每个会员每日购买的最大数量，0为不限购')}}</div>
    </el-form-item>
    <el-form-item :label="$t('排序')">
      <el-input type="number" v-model="form.group_sort" :placeholder="$t('请输入数字')" class="max-w460"></el-input>
    </el-form-item>

    <Upload v-if="isupload" :config="{ total: 9 }" :isupload="isupload" @returnImgs="returnImgsFunc">{{ $t('上传图片') }}
    </Upload>
  </div>
</template>

<script>
import GroupApi from '@/api/group.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    draggable
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      /*form表单数据*/
    };
  },
  inject: ['form'],
  methods: {
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        let imgs = this.form.image.concat(e);
        this.$set(this.form, 'image', imgs);
      }
      this.isupload = false;
    },
    /*删除图片*/
    deleteImg(index) {
      this.form.image.splice(index, 1);
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper>span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingtool/group/group/part/Basic.vue